module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/password-reset-6934932c8bc1ccece5a61979f6f886e2.jpg";